import React, { Suspense, lazy } from "react";
import { useParams } from "react-router-dom";
import { engineGatewayUrl } from "./engineConfig";
import { Muted, Page, Panel } from "./ui";

// Loaded only when a catering link is opened, so Stripe's script stays off other pages.
const EngineCatering = lazy(() => import("./EngineCatering"));

// /cater/<secret>: the catering order link a restaurant texted. Catering
// orders run on the V2 engine only; a build without a gateway says so.
const CaterRouter = () => {
	const { secret } = useParams();
	const gatewayUrl = engineGatewayUrl();
	const waiting = (
		<Page>
			<Panel>
				<Muted aria-live="polite">{gatewayUrl ? "Loading your catering order..." : "Catering orders aren't available on this site."}</Muted>
			</Panel>
		</Page>
	);
	if (!gatewayUrl) return waiting;
	return (
		<Suspense fallback={waiting}>
			<EngineCatering key={secret} gatewayUrl={gatewayUrl} secret={secret} />
		</Suspense>
	);
};

export default CaterRouter;
